import { RouteRecordRaw } from 'vue-router'

const RegisterInfluencer = () =>
  import(/* webpackChunkName: "influencer-view" */ './pages/influencers.vue')
const RegisterBusiness = () =>
  import(/* webpackChunkName: "business-view" */ './pages/business.vue')
const RegisterSuccess = () =>
  import(/* webpackChunkName: "successful-view" */ './pages/successful.vue')
const RegisterSuccessBusiness = () =>
  import(
    /* webpackChunkName: "successful-business" */ './pages/successful-business.vue'
  )
export const registersRoutes: Array<RouteRecordRaw> = [
  {
    path: '/registers',
    name: 'registers',
    redirect: '/registers/business',
  },
  {
    path: '/registers/influencer',
    name: 'register-influencer',
    component: RegisterInfluencer,
  },
  {
    path: '/registers/business',
    name: 'register-business',
    component: RegisterBusiness,
  },
  {
    path: '/registers/success/:type',
    name: 'register-success',
    component: RegisterSuccess,
  },
  {
    path: '/registers/success-business',
    name: 'register-success-business',
    component: RegisterSuccessBusiness,
  },
]
